import Cookie from '../Cookie/Cookie';

/**
 * Class Language
 */
class Language {
    /** @var **/
    static languageCookieKey = 'locale';

    /**
     * @return {string|*}
     */
    static get() {
        const html = document.querySelector("html");

        if (! html) {
            throw new Error("Html element cannot be found.");
        }

        const locale = html.getAttribute("lang");

        Cookie.set(this.languageCookieKey, locale);

        return locale;
    }
}

export default Language;
